// v2 - dynamic category content support
const { liteClient: algoliasearch } = window["algoliasearch/lite"];
const searchClient = algoliasearch(window.algoliaConfig.appId, window.algoliaConfig.searchKey);

// Tell prerender.io to wait for the Algolia results to actually render before
// snapshotting. Flipped to true in the search 'render'/'error' handlers below,
// not on a timer, so the crawler never captures a mid-fetch/empty grid.
window.prerenderReady = false;

//const {panel} = instantsearch.widgets.panel;
const indexName = document.getElementById('js-aisIndexName').value;
const categoryName = document.getElementById('js-aisParentCategoryName').value;
const searchMode = document.getElementById('js-aisSearchMode').value;
const childCategoryName = document.getElementById('js-aisChildCategoryName').value;
const searchTerm = document.getElementById('js-aisSearchTerm').value;
// Category group (e.g. None | Specialty Stores ...)
// const categoryGroupName = document.getElementById('js-aisCategoryGroupName')?.value || '';
let categoryGroupName = '';

const categoryGroupNameEl = document.getElementById('js-aisCategoryGroupName');
if (categoryGroupNameEl) {
    categoryGroupName = categoryGroupNameEl.value;
}
// Explicit parent category URL (server-provided) for child category breadcrumb accuracy
// const parentCategoryUrlRaw = document.getElementById('js-aisParentCategoryUrl')?.value || '';
let parentCategoryUrlRaw = '';

const parentCategoryUrlRawEl = document.getElementById('js-aisParentCategoryUrl');
if (parentCategoryUrlRawEl) {
    parentCategoryUrlRaw = parentCategoryUrlRawEl.value;
}
const aisBreadCrumbs = document.getElementById('js-aisBreadCrumbs');
const searchTermResults = document.getElementById('js-searchTermResults');
// Get the presentation id (element may not exist if this is not a Presentations Author)
// const presentationId = parseInt(document.getElementById('js-PresentationId')?.value || '-1');
let presentationId = -1;

const presentationIdEl = document.getElementById('js-PresentationId');
if (presentationIdEl && presentationIdEl.value) {
    presentationId = parseInt(presentationIdEl.value, 10);
}
const canonicalLink = document.querySelector('link[rel="canonical"]');
const canonicalUrl = canonicalLink ? canonicalLink.getAttribute('href') : window.location.href;
const pageCleanUrl = cleanUrl(canonicalUrl);

function normalizeCategory(categoryName) {
    return categoryName
        .replace(/>/g, "-")
        .replace(/"/g, "'")
        .trim();
}

// Initialize the UI state
// JSON-LD Structured Data Functions
function getMetaDescription() {
    const m = document.querySelector('meta[name="description"]');
    return m ? m.getAttribute('content') : '';
}
function getSiteName() {
    const og = document.querySelector('meta[property="og:site_name"]');
    if (og) return og.getAttribute('content');
    const title = document.title || '';
    return title.split('|').pop().trim();
}

// Helper to strip query/hash from URLs for structured data
function cleanUrl(raw) {
    try { const u = new URL(raw, window.location.origin); u.search = ''; u.hash = ''; return u.toString(); } catch { return raw.split('?')[0]; }
}

function createBreadcrumbListSchema() {
    const breadcrumbItems = [];
    let position = 1;

    const canonicalBaseUrl = new URL(pageCleanUrl).origin + '/';
    const parentCategoryAbsUrl = parentCategoryUrlRaw ? cleanUrl(parentCategoryUrlRaw.startsWith('http') ? parentCategoryUrlRaw : window.location.origin + parentCategoryUrlRaw) : '';

    // breadcrumbItems.push({
    //     '@type': 'ListItem',
    //     position: position++,
    //     item: {
    //         '@id': canonicalBaseUrl,
    //         name: getSiteName() || 'Home'
    //     }
    // });

    if (categoryName) {
        if (categoryGroupName === 'Specialty Stores') {
            breadcrumbItems.push({
                '@type': 'ListItem',
                position: position++,
                item: {
                    '@id': new URL(pageCleanUrl).origin + '/specialtystores',
                    name: 'Specialty Stores'
                }
            });
            breadcrumbItems.push({
                '@type': 'ListItem',
                position: position++,
                item: {
                    '@id': pageCleanUrl,
                    name: categoryName
                }
            });
        } else if (childCategoryName) {
            // Parent category list item (use parentCategoryAbsUrl if provided)
            breadcrumbItems.push({
                '@type': 'ListItem',
                position: position++,
                item: {
                    '@id': parentCategoryAbsUrl || pageCleanUrl,
                    name: categoryName
                }
            });
            // Child category (current page)
            breadcrumbItems.push({
                '@type': 'ListItem',
                position: position++,
                item: {
                    '@id': pageCleanUrl,
                    name: childCategoryName
                }
            });
        } else {
            breadcrumbItems.push({
                '@type': 'ListItem',
                position: position++,
                item: {
                    '@id': pageCleanUrl,
                    name: categoryName
                }
            });
        }
    } else if (searchTerm) {
        let breadcrumbName = `Search results for "${searchTerm}"`;
        if (searchMode === 'Brand') {
            // const brandName = document.getElementById('js-aisBrandName')?.value;
            let brandName;

            const el = document.getElementById('js-aisBrandName');
            if (el) {
                brandName = el.value;
            }
            breadcrumbName = brandName || searchTerm;
        } else if (searchMode === 'Flag' && searchTerm === 'Sale') {
            breadcrumbName = 'On Sale';
        }
        breadcrumbItems.push({
            '@type': 'ListItem',
            position: position++,
            item: {
                '@id': pageCleanUrl,
                name: breadcrumbName
            }
        });
    }

    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbItems
    };
}

function createItemListSchema(hits, totalHits, currentPage = 0, hitsPerPage = 60) {
    const listItems = hits.map((hit, index) => {
        const productUrl = hit.canonicalUrl;
        return {
            '@type': 'ListItem',
            '@id': productUrl + '#product',
            position: (currentPage * hitsPerPage) + index + 1,
            name: hit.name,
            url: productUrl, // already clean (constructed without query)
            image: hit.imageUrl300J || hit.imageUrl300P || hit.imageUrl240J || hit.imageUrl240P,
        };
    });

    let listName = getSiteName() || 'Products';
    if (categoryName) {
        listName = childCategoryName ? `${categoryName} - ${childCategoryName}` : categoryName;
        if (categoryGroupName === 'Specialty Stores') {
            listName = `Specialty Store - ${categoryName}`;
        }
    } else if (searchTerm) {
        if (searchMode === 'Brand') {
            // const brandName = document.getElementById('js-aisBrandName')?.value;
            let brandName;

            const el = document.getElementById('js-aisBrandName');
            if (el) {
                brandName = el.value;
            }
            listName = brandName || searchTerm;
        } else if (searchMode === 'Flag' && searchTerm === 'Sale') {
            listName = 'On Sale Products';
        } else {
            listName = `Search Results for "${searchTerm}"`;
        }
    }

    return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        '@id': pageCleanUrl + '#category',
        name: listName,
        url: pageCleanUrl,
        description: getMetaDescription() || listName,
        numberOfItems: totalHits,
        itemListElement: listItems
    };
}

function updateJsonLD(hits, totalHits, currentPage = 0, hitsPerPage = 60) {
    // Remove existing JSON-LD scripts
    const existingScripts = document.querySelectorAll('script[data-algolia-jsonld]');
    existingScripts.forEach(script => script.remove());

    // Create and insert ItemList schema
    const itemListSchema = createItemListSchema(hits, totalHits, currentPage, hitsPerPage);
    const itemListScript = document.createElement('script');
    itemListScript.type = 'application/ld+json';
    itemListScript.setAttribute('data-algolia-jsonld', 'itemlist');
    itemListScript.textContent = JSON.stringify(itemListSchema);
    document.head.appendChild(itemListScript);

    // Create and insert BreadcrumbList schema
    const breadcrumbSchema = createBreadcrumbListSchema();
    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.setAttribute('data-algolia-jsonld', 'breadcrumb');
    breadcrumbScript.textContent = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(breadcrumbScript);

    console.log('JSON-LD updated:', { itemList: itemListSchema, breadcrumb: breadcrumbSchema });
}

// The category is encoded in the URL PATH (/browse/{slug}[/page/N]), never in
// the query string. This helper derives the InstantSearch hierarchicalMenu UI
// state for the current category from the server-provided names, so it can be
// applied to the initial uiState AND re-injected by the router's parseURL() on
// direct paged loads / back-forward (where the URL query no longer carries it).
function getCategoryHierarchicalMenu() {
    if (!categoryName) return null;
    if (searchTerm && searchMode !== 'Brand' && searchMode !== 'Flag') return null;
    // We don't set the lvl1 state here because the widget filters out
    // all other sibling categories when you pick an explicit lvl1 and we
    // want to show all siblings. Setting the lvl0 state as shown here
    // indicates to the widget both which parent category is expanded as
    // well as which child category is being shown, without removing others.
    // This doesn't seem to be documented, but was deduced from the source.
    // In order for the siblings to show, however, the actual filter (below) must
    // result in products being returned that are in those sibling categories.
    // This is because the widget only renders categories that are present in
    // the current hit results but filters out hits based on the selected lvl.
    const hState = childCategoryName
        ? normalizeCategory(categoryName) + " > " + normalizeCategory(childCategoryName)
        : normalizeCategory(categoryName);
    return { 'hierarchicalCategories.lvl0': [hState] };
}

// Initial page (1-based) provided by the server for a /page/N route.
const initialPageEl = document.getElementById('js-aisInitialPage');
const initialPage = (initialPageEl && parseInt(initialPageEl.value, 10)) || 1;

let uiState = {
    [indexName]: {}
};

if (searchTerm && searchMode !== 'Brand' && searchMode !== 'Flag') {
    uiState[indexName].query = searchTerm;
} else if (categoryName) {
    aisBreadCrumbs.classList.remove('d-none');
    uiState[indexName].hierarchicalMenu = getCategoryHierarchicalMenu();
}

// Seed the initial page from the server route (/page/N). Page 1 is the default,
// so only set it for N >= 2.
if (initialPage >= 2) {
    uiState[indexName].page = initialPage;
}

// Track last category refinement so we can detect changes and fetch updated content.
// Starts as a sentinel so we can distinguish "not yet initialized" from "no refinement".
let lastCategoryRefinement = '__initial__';

// ---- Algolia Insights stub (safe even when the real script isn't loaded yet) ----
// Pass to instantsearch() if used:
// insights: {
//     insightsClient, // wrapper/stub
// },
// const insightsClient =
//     (typeof window.aa === 'function' && window.aa) ||
//     function () {
//         // store queued calls on the stub itself (NOT on window.aa)
//         (insightsClient.queue = insightsClient.queue || []).push(arguments);
//     };


// Desired pathname for the browser URL. Updated by the category-content
// API response; the router's push() uses this so there's no race.
let categoryPathname = window.location.pathname;

// Pagination lives in the PATH (/page/N), not the query string. This keeps
// clean paged URLs free of '?' so they pass the prerender whitelist and get
// indexed, while facets/sort/query stay in '?' (blacklisted from prerender,
// as intended). See the custom createURL/parseURL below.
const PAGE_SEG_RE = /\/page\/(\d+)\/?$/;
const stripPageSeg = (p) => p.replace(PAGE_SEG_RE, '');

// Create instant search instance
const search = instantsearch(
    {
        indexName: indexName,
        searchClient,
        routing: {
            router: instantsearch.routers.history({
                // Serialize UI state -> URL. `page` is hoisted into the path
                // (/page/N, omitted for page 1); everything else (facets, sort,
                // query) is serialized into the query string exactly as before.
                createURL({ qsModule, routeState }) {
                    const idx = routeState[indexName] || {};
                    // `page` -> path (/page/N); `hierarchicalMenu` (the category) is
                    // already in the path, so drop it. Everything else (user facets,
                    // sort, query) is serialized into the query string as before.
                    const { page, hierarchicalMenu, ...rest } = idx;
                    const routeForQuery = Object.keys(rest).length ? { [indexName]: rest } : {};
                    const queryString = qsModule.stringify(routeForQuery, { addQueryPrefix: true });
                    const base = stripPageSeg(categoryPathname);
                    const n = Number(page) || 1;
                    return `${n >= 2 ? `${base}/page/${n}` : base}${queryString}`;
                },
                // Parse URL -> UI state. `page` is read from the path segment;
                // facets/sort/query are parsed from the query string. This is what
                // restores full state on a fresh load / refresh / back-forward.
                parseURL({ qsModule, location }) {
                    const routeState = qsModule.parse(location.search, { ignoreQueryPrefix: true }) || {};
                    const idx = routeState[indexName] || {};
                    // page comes from the path segment (/page/N)
                    const m = location.pathname.match(PAGE_SEG_RE);
                    if (m) idx.page = Number(m[1]);
                    // Re-inject the category (hierarchicalMenu) from the server-provided
                    // names; it lives in the path, not the query. Without this a direct
                    // /page/N load or a back/forward would drop the category refinement,
                    // because InstantSearch REPLACES (not merges) initialUiState when the
                    // URL provides state for the index.
                    if (!idx.hierarchicalMenu) {
                        const catMenu = getCategoryHierarchicalMenu();
                        if (catMenu) idx.hierarchicalMenu = catMenu;
                    }
                    if (Object.keys(idx).length) routeState[indexName] = idx;
                    return routeState;
                },
                push(url) {
                    // Rebase the path onto our tracked value (subcategory drill-in),
                    // preserving the /page/N segment and query string InstantSearch
                    // produced. Rebasing at push() time avoids the category-content
                    // API race.
                    const parsed = new URL(url, window.location.origin);
                    const m = parsed.pathname.match(PAGE_SEG_RE);
                    parsed.pathname = stripPageSeg(categoryPathname) + (m ? `/page/${m[1]}` : '');
                    window.history.pushState({}, '', parsed.toString());
                },
            }),
        },
        initialUiState: uiState,
        insights: {
            insightsInitParams: {
                useCookie: true,
            },
            // Disable automatic events - we'll control them manually
            onEvent: (event, aa) => {
                const { insightsMethod, payload } = event;

                if (!insightsMethod) return;

                // Always pass through conversion events
                if (insightsMethod.includes('conversion')) {
                    aa(insightsMethod, payload);
                    return;
                }

                // Pass through filter click events (have 'filters' in payload)
                // but NOT hit click events (have 'objectIDs' in payload)
                // Hit clicks are handled manually to include url field
                if (insightsMethod.includes('click') && payload.filters) {
                    aa(insightsMethod, payload);
                    return;
                }

                // All other events (hit clicks, views) are handled manually
            },
        },
    });

// Algolia Search Analytics tuning, driven entirely by hidden fields the server stamps:
//  * `analytics: false` for bot/prerender traffic, so those searches are never recorded - browse
//    is client-side Algolia, so prerender.io's headless render really does hit Algolia, and it
//    renders from a US datacentre where no geographic tag could tell it from a real customer.
//  * `analyticsTags` carrying the visitor's Cloudflare country, because Algolia has no built-in
//    way to segment Analytics by geography. These tag values are what the dashboard segments on:
//    https://www.algolia.com/doc/guides/search-analytics/guides/segments
const ANALYTICS_TAG_RE = /^[a-z]+:[A-Za-z0-9_.-]{1,32}$/;

function getAnalyticsTags() {
    const el = document.getElementById('js-aisAnalyticsTags');
    if (!el || !el.value) return [];
    // Defensive: the server already constrains these, but a malformed tag would be sent
    // verbatim to Algolia and pollute the segment list, so drop anything unexpected.
    return el.value
        .split(',')
        .map((t) => t.trim())
        .filter((t) => ANALYTICS_TAG_RE.test(t));
}

// Build consolidated configuration object
const configOptions = {
    maxValuesPerFacet: 1000,
};

// Algolia Search Analytics (see the notes above). Bot traffic opts out of analytics wholesale;
// everyone else carries the country segment tag.
if (document.getElementById('js-aisAnalyticsEnabled')?.value === 'false') {
    configOptions.analytics = false;
} else {
    const analyticsTags = getAnalyticsTags();
    if (analyticsTags.length) {
        configOptions.analyticsTags = analyticsTags;
    }
}

// Add category filters
if (categoryName) {
    const filter = childCategoryName
        ? 'hierarchicalCategories.lvl0:"' + categoryName + '" OR hierarchicalCategories.lvl1:"' + categoryName + ' >"'
        : 'hierarchicalCategories.lvl0:"' + categoryName + '"';
    configOptions.filters = filter;
    // TEMP DEBUG
    configOptions.getRankingInfo = true;
}

// Add search mode filters
if (searchMode === 'Flag') {
    configOptions.filters = `flags:'${searchTerm}'`;
}

if (searchMode === 'Brand') {
    configOptions.filters = `brandSlug:'${searchTerm}'`;
}

// Add single consolidated configure widget
search.addWidgets([
    instantsearch.widgets.configure(configOptions),
]);

// CUSTOM WIDGETS START //
const { connectClearRefinements } = instantsearch.connectors;

// 1. Create a render function
const renderClearRefinements = ({ refine, widgetParams }, isFirstRender) => {
    // Rendering logic
    const { container } = widgetParams;
    // Container might already be a DOM element from panel widget
    const containerNode = typeof container === 'string' ? document.querySelector(container) : container;

    if (!containerNode) {
        console.error('Container not found for minimum order quantity slider');
        return;
    }
    const algoliaFilter = document.getElementById('facets-container');
    const toggleMenu = () => {
        algoliaFilter.classList.add('show');
        document.body.classList.toggle('tag-no-scroll');
    }

    if (isFirstRender) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('ais-ClearRefinements', 'mb-4');
        const button = document.createElement('button');
        button.classList.add('ais-ClearRefinements-button', 'btn', 'tag-btn-outline-theme-primary', 'w-100');
        button.textContent = 'Clear Filters';

        button.addEventListener('click', () => {
            refine();
            toggleMenu;
        });

        wrapper.appendChild(button);
        containerNode.appendChild(wrapper);
    }
};
// 2. Create the custom widget
const customResetFilterBtn = connectClearRefinements(
    renderClearRefinements
);

// CUSTOM WIDGETS END //

// CUSTOM RANGE SLIDER WIDGET WITHOUT DOLLAR SIGNS //
const { connectRange } = instantsearch.connectors;

const renderMinOrderQtyRange = (renderOptions, isFirstRender) => {
    const {
        start,
        range,
        canRefine,
        refine,
        widgetParams,
    } = renderOptions;

    const { container } = widgetParams;
    const containerNode = container;

    if (isFirstRender) {
        // Create widget with Algolia styling
        const wrapper = document.createElement('div');
        wrapper.className = 'ais-RangeSlider minimum-order-qty-slider';

        const form = document.createElement('form');
        form.className = 'ais-RangeSlider-form';

        const inputContainer = document.createElement('div');
        inputContainer.className = 'ais-RangeSlider-inputContainer input-group';

        const input = document.createElement('input');
        input.className = 'ais-RangeSlider-input form-control form-control-sm';
        input.type = 'number';
        input.placeholder = 'min qty';
        input.step = '1';
        input.min = '1';
        input.setAttribute('aria-label', 'Minimum order quantity');

        const submitButton = document.createElement('button');
        submitButton.className = 'ais-RangeSlider-submit btn btn-sm tag-btn-outline-theme-primary';
        submitButton.type = 'submit';
        submitButton.innerHTML = '<i class="bi bi-arrow-clockwise"></i>';
        submitButton.setAttribute('aria-label', 'Apply minimum quantity filter');

        const clearButton = document.createElement('button');
        clearButton.className = 'ais-RangeSlider-clear btn btn-sm tag-btn-outline-theme-primary';
        clearButton.type = 'button';
        clearButton.innerHTML = '<span class="bi bi-x"></span>';
        clearButton.setAttribute('aria-label', 'Clear minimum quantity filter');

        // Assemble the form
        inputContainer.appendChild(input);
        inputContainer.appendChild(submitButton);
        inputContainer.appendChild(clearButton);
        // form.appendChild(label);
        form.appendChild(inputContainer);
        wrapper.appendChild(form);

        containerNode.appendChild(wrapper);

        // Store references
        containerNode._input = input;
        containerNode._form = form;

        // Handle form submission
        form.addEventListener('submit', (event) => {
            event.preventDefault();

            const maxValue = input.value ? parseInt(input.value, 10) : undefined;

            // Refine with undefined min and specified max (filter: minimumOrderQty <= maxValue)
            refine([undefined, maxValue]);
        });

        // Handle clear
        clearButton.addEventListener('click', () => {
            input.value = '';
            refine([undefined, undefined]); // Clear the refinement
        });

        // Handle real-time updates on input change
        input.addEventListener('input', () => {
            if (input.value === '') {
                refine([undefined, undefined]); // Clear when empty
            }
        });
    }

    // Update the widget
    const input = containerNode._input;
    const form = containerNode._form;

    console.log('Min Order Qty render:', { range, canRefine, start });

    if (range) {
        const { min: rangeMin, max: rangeMax } = range;
        const [currentMin, currentMax] = start;

        // Validate range values
        const validMax = isFinite(rangeMax) ? rangeMax : 1000;

        console.log('Valid range:', { rangeMin, rangeMax, currentMax, validMax });

        // Set input constraints based on available data
        input.max = validMax;
        //input.placeholder = `up to ${validMax}`;

        // Set current value (only care about the max value)
        input.value = Number.isFinite(currentMax) ? String(currentMax) : '';

        // Enable/disable based on refinement capability
        input.disabled = !canRefine;

        form.style.display = 'block';
    } else {
        console.log('No range data available');
        form.style.display = 'none';
    }
};

// Create the custom widget
const customMinOrderQtyRange = connectRange(renderMinOrderQtyRange);

// CUSTOM SEARCH TERM WIDGET //
const { connectSearchBox } = instantsearch.connectors;
const renderSearchTerm = (renderOptions, isFirstRender) => {
    const {
        query,
        refine,
        clear,
        isSearchStalled,
        widgetParams,
    } = renderOptions;

    const container = document.querySelector('#js-searchTermResults');
    if (isFirstRender && searchTerm.length > 0) {
        let d = document.createElement('div');
        d.classList.add('ais-Breadcrumb');

        const l = document.createElement('ul');
        l.classList.add('ais-Breadcrumb-list');

        // let i = document.createElement('li');
        // i.classList.add('ais-Breadcrumb-item');
        //
        // let a = document.createElement('a');
        // a.classList.add('ais-Breadcrumb-link');
        // a.textContent = 'Home';
        // a.href = '/';
        //
        // i.appendChild(a)
        //
        // l.appendChild(i);

        let i = document.createElement('li');
        i.classList.add('ais-Breadcrumb-item');

        i = document.createElement('li');
        i.classList.add('ais-Breadcrumb-item', 'ais-Breadcrumb-item--selected');

        let a = document.createElement('a');
        a.classList.add('ais-Breadcrumb-link');
        a.setAttribute('href', window.location.href);
        if (searchMode == '') {
            a.textContent = 'Search results for "' + query + '"';
        } else if (searchMode == 'Brand') {
            const displayName = document.getElementById('js-aisBrandName').value;
            a.textContent = displayName;
        } else if (searchMode == 'Flag' && searchTerm == 'Sale') {
            a.textContent = 'On Sale';
        }

        i.appendChild(a);

        l.appendChild(i);

        // Add the "search breadcrumb"
        d.appendChild(l);
        container.appendChild(d);

        // Add the text in place of the category
        d = document.createElement('div');
        d.classList.add('row');

        let h1 = document.createElement('h1');
        h1.classList.add('pb-2', 'mb-3', 'border-bottom');

        if (searchMode == '') {
            h1.textContent = 'Matching Results For "' + query + '"';
        } else if (searchMode == 'Brand') {
            // const displayName = document.getElementById('js-aisBrandName').value;
            // h1.textContent = displayName;
        } else {
            //h1.textContent = "Matching Products";
        }

        // Only append if h1 has content
        if (h1.textContent) {
            d.appendChild(h1);
            container.appendChild(d);
        }

    }
}

const customSearchTerm = connectSearchBox(renderSearchTerm);

search.addWidgets([
    instantsearch.widgets.searchBox({
        container: '#HiddenSearchTerm',
        searchAsYouType: false,
        showSubmit: false,
        showLoadingIndicator: false
    }),
    customSearchTerm({}),
    instantsearch.widgets.hits({
        container: '#js-aisHits',
        templates: {
            empty: function (results, { html }) {
                return html`<div id="tag-no-results-container" class="text-danger text-center">No results found.</div>`;
            },
            item(hit, { html, components, sendEvent }) {
                let flags = html`${hit.flags.map((flag) => {
                    if (flag) {
                        switch (flag) {
                            case "New Product":
                                return html`<li class="tag-new">${flag}</li>`;
                            case "Free Shipping":
                                return html`<li class="tag-free-shipping">${flag}</li>`;
                            case "Sale":
                                return html`<li class="tag-sale">${flag}</li>`;
                            case "QuickShip":
                                return html`<li class="tag-quickship">${flag}</li>`;
                            case "Full Color!":
                                return html`<li class="tag-full-color">${flag}</li>`;
                            default:
                                return html`<li>${flag}</li>`
                        }
                    } else {
                        return null
                    }

                })}`;
                let addToCatalogBtn = html`<button class="btn btn-sm btn-success js-add-product-to-presentation ms-1 mt-2" data-coBrandProductId="${hit.coBrandProductId}">Add to Catalog</button>`;
                // TEMPORARY UNTIL INDEX IS FULLY POPULATED WITH SLUG
                let slug = hit.slug ? hit.slug : hit.name + '_' + hit.coBrandProductId;
                return html`
                          <div class="card flex-grow-1 rounded-0">
                              <ul class="flags">
                                  ${flags}
                              </ul>
                              <div class="align-self-center px-2 pt-3">
                                  <a href="/products/${slug}"
                                     aria-label="${hit.name}"
                                     class="text-decoration-none"
                                     onClick="${() => {
                    // Algolia click event ✅
                    try {
                        window.aa('clickedObjectIDsAfterSearch', {
                            index: hit.__indexName || indexName,
                            eventName: 'Product Details',
                            objectIDs: [hit.objectID],
                            queryID: hit.__queryID || '',
                            positions: [hit.__position || 1],
                            url: cleanUrl(window.location.href)
                        });
                    } catch {}

                    // store attribution for conversion tracking later ✅
                    try {
                        // Store per productId so multiple products can be tracked
                        // without overwriting each other
                        const attribMap = JSON.parse(sessionStorage.getItem('algolia_attrib_map') || '{}');
                        attribMap[hit.objectID] = {
                            index: hit.__indexName || indexName,
                            objectID: hit.objectID,
                            queryID: hit.__queryID || '',
                            position: hit.__position || null
                        };
                        sessionStorage.setItem('algolia_attrib_map', JSON.stringify(attribMap));
                    } catch {}
                }}">
                                      <picture>
                                          <source data-srcset="${hit.imageUrl240P} 240w" media="(max-width: 575.98px)" type="image/webp" />
                                          <source data-srcset="${hit.imageUrl300P} 300w" media="(min-width: 576px) and (max-width: 991.98px)" type="image/webp" />
                                          <source data-srcset="${hit.imageUrl210P} 210w" media="(min-width: 992px) and (max-width: 1399.98px)" type="image/webp" />
                                          <source data-srcset="${hit.imageUrl300P} 300w" media="(min-width: 1400px)" type="image/webp" />
                                          <source data-srcset="${hit.imageUrl240J} 240w" media="(max-width: 575.98px)" type="image/jpeg" />
                                          <source data-srcset="${hit.imageUrl300J} 300w" media="(min-width: 576px) and (max-width: 991.98px)" type="image/jpeg" />
                                          <source data-srcset="${hit.imageUrl210J} 210w" media="(min-width: 992px) and (max-width: 1399.98px)" type="image/jpeg" />
                                          <source data-srcset="${hit.imageUrl300J} 300w" media="(min-width: 1400px)" type="image/jpeg" />
                                          <img class="card-img-top img-fluid lazyload" height="300" width="300" src="${hit.imageUrl300J}" alt="${hit.name} - ${hit.sku}" />
                                      </picture>

                                      <p class="card-title mt-3">
                                          <strong>
                                              ${components.Highlight({ attribute: 'name', hit })}
                                          </strong>
                                      </p>
                                      <p class="small info-text">
                                         ${hit.sku}${hit.price > 0 ? ` as low as $${Number(hit.price).toFixed(2)}` : ''}
                                      </p>
                                      ${hit.reviewCount > 0 ? html`
                                      <p class="small mb-0 js-rating text-warning"
                                         aria-label="Rated ${Number(hit.averageRating).toFixed(1)} out of 5 from ${hit.reviewCount} review${hit.reviewCount === 1 ? '' : 's'}">
                                          ${[1, 2, 3, 4, 5].map((i) => {
                        const r = Number(hit.averageRating) || 0;
                        const cls = r >= i ? 'bi-star-fill' : (r >= i - 0.5 ? 'bi-star-half' : 'bi-star');
                        return html`<span class="bi ${cls}"></span>`;
                    })}
                                          <span class="text-muted ms-1">(${hit.reviewCount})</span>
                                      </p>` : ''}
                                  </a>
                              </div>
                              <div class="card-body pt-0">
                                  <div class="d-flex justify-content-center">
                              <button
                                      class="btn tag-btn-theme-primary js-open-quickview-modal mt-2"
                                      data-prodId="${hit.coBrandProductId}"
                                      data-algolia-index="${hit.__indexName || indexName}"
                                      data-algolia-objectid="${hit.objectID}"
                                      data-algolia-queryid="${hit.__queryID || ''}"
                                      data-algolia-position="${hit.__position || ''}"
                                      onClick="${(event) => {
                    try {
                        window.aa('clickedObjectIDsAfterSearch', {
                            index: hit.__indexName || indexName,
                            eventName: 'Quick View',
                            objectIDs: [hit.objectID],
                            queryID: hit.__queryID || '',
                            positions: [hit.__position || 1],
                            url: cleanUrl(window.location.href)
                        });
                    } catch {}
                }}"
                                      >
                                          Quick View
                                      </button>
                                      ${presentationId > 0 ? addToCatalogBtn : ''}
                                  </div>
                              </div>
                          </div>` ;
            }
        },
        cssClasses: {
            root: '',
            list: ['row'],
            item: ['col-6', 'col-sm-6', 'col-lg-4', 'col-xl-3', 'd-flex', 'py-0', 'mb-4']
        },
    }),
    instantsearch.widgets.dynamicWidgets({
        container: '#tag-filterContainer',
        // /onsale is already hard-filtered to flags:'Sale', so the Sale toggle
        // would be redundant there — strip it from the dynamic facet list.
        transformItems(items) {
            const isOnSalePage = searchMode === 'Flag' && searchTerm === 'Sale';
            return isOnSalePage ? items.filter(a => a !== 'flags') : items;
        },
        fallbackWidget: ({ container, attribute }) =>
            instantsearch.widgets.panel({
                hidden(options) {
                    return !options.isFromSearch && options.items.length === 0;
                },
                collapsed: () => { return false },
                templates: {
                    header: attribute.replace(/_/g, ' '),
                    collapseButtonText: function (options, { html }) {
                        return html`<i class="bi ${options.collapsed ? 'bi-plus' : 'bi-dash'}"></i>`;
                    }
                }
            })(instantsearch.widgets.refinementList)({
                container, attribute
            }),
        widgets: [
            container => instantsearch.widgets.panel({
                collapsed: () => {
                    return false
                },
                templates: {
                    container: container,
                    header: "Categories",
                    collapseButtonText: function (options, { html }) {
                        return html`<i class="bi ${options.collapsed ? 'bi-plus' : 'bi-dash'}"></i>`;
                    },
                },
                hidden: (options) => categoryName.length > 0,
            })(instantsearch.widgets.refinementList)({
                container: container,
                attribute: 'categories'
            }),
            container => instantsearch.widgets.panel({
                collapsed: () => {
                    return false
                },
                templates: {
                    container: container,
                    header: "Categories",
                    collapseButtonText: function (options, { html }) {
                        return html`<i class="bi ${options.collapsed ? 'bi-plus' : 'bi-dash'}"></i>`;
                    },
                },
                hidden: () => categoryName.length == 0,
            })(instantsearch.widgets.hierarchicalMenu)({
                container: container,
                attributes: [
                    'hierarchicalCategories.lvl0',
                    'hierarchicalCategories.lvl1'
                ],
                showParentLevel: true,
                // Without these, the widget caps the list at the default limit of 10.
                // Show 10 collapsed, then a "Show more" link expands the rest.
                limit: 10,
                showMore: true,
                showMoreLimit: 1000,
                templates: {
                    showMoreText: function (data, { html }) {
                        return html`<span>${data.isShowingMore ? 'Show less' : 'Show more'}</span>`;
                    },
                },
                transformItems(items) {
                    if (categoryName) {
                        // Check if the current category has subcategories
                        const currentCategoryItem = items.find(item => item.label === categoryName);
                        const hasSubcategories = currentCategoryItem && currentCategoryItem.data && currentCategoryItem.data.length > 0;

                        if (hasSubcategories) {
                            // Ensure current category appears at the top, followed by its children
                            const filtered = items.filter(item => {
                                return item.label === categoryName ||
                                    (item.label.includes(' > ') && item.label.startsWith(categoryName + ' > '));
                            });

                            // Sort to ensure current category is first
                            return filtered.sort((a, b) => {
                                if (a.label === categoryName) return -1;
                                if (b.label === categoryName) return 1;
                                return 0;
                            });
                        }
                    }
                    return items;
                }
            }),

            container => instantsearch.widgets.panel({
                collapsed: () => {
                    return false;
                },
                templates: {
                    header: 'Minimum Order Quantity',
                    collapseButtonText: function (options, { html }) {
                        return html`<i class="bi ${options.collapsed ? 'bi-plus' : 'bi-dash'}"></i>`;
                    }
                }
            })
            (customMinOrderQtyRange)({
                container: container,
                attribute: 'minimumOrderQty'
            }),
            container => instantsearch.widgets.panel({
                collapsed: () => {
                    return false;
                },
                templates: {
                    header: 'Shipping',
                    collapseButtonText: function (options, { html }) {
                        return html`<i class="bi ${options.collapsed ? 'bi-plus' : 'bi-dash'}"></i>`;
                    },
                }
            })
            (instantsearch.widgets.toggleRefinement)
            ({
                container: container,
                attribute: 'freeShipping',
                templates: {
                    labelText: 'Free Shipping',
                }
            }),
            container => instantsearch.widgets.panel({
                collapsed: () => {
                    return false;
                },
                templates: {
                    header: 'Imprint Color',
                    collapseButtonText: function (options, { html }) {
                        return html`<i class="bi ${options.collapsed ? 'bi-plus' : 'bi-dash'}"></i>`;
                    },
                }
            })
            (instantsearch.widgets.toggleRefinement)
            ({
                container: container,
                attribute: 'fullColorImprint',
                templates: {
                    labelText: 'Full Color',
                }
            }),
            // Sale toggle. dynamicWidgets gating (whether to render at all)
            // is handled in transformItems above.
            container => instantsearch.widgets.panel({
                collapsed: () => {
                    return false;
                },
                templates: {
                    header: 'Sale',
                    collapseButtonText: function (options, { html }) {
                        return html`<i class="bi ${options.collapsed ? 'bi-plus' : 'bi-dash'}"></i>`;
                    },
                }
            })
            (instantsearch.widgets.toggleRefinement)
            ({
                container: container,
                attribute: 'flags',
                on: 'Sale',
                templates: {
                    labelText: 'On Sale',
                }
            }),
            container => instantsearch.widgets.panel({
                collapsed: () => {
                    return false;
                },
                templates: {
                    header: 'Price Range',
                    collapseButtonText: function (options, { html }) {
                        return html`<i class="bi ${options.collapsed ? 'bi-plus' : 'bi-dash'}"></i>`;
                    },
                },
                cssClasses: {
                    root: 'tag-ais-price-refinement-container',
                }
            })
            (instantsearch.widgets.rangeSlider)
            ({
                pips: false,
                container: container,
                attribute: 'price',
            }),
            container => instantsearch.widgets.panel({
                collapsed: () => {
                    return false;
                },
                templates: {
                    header: 'Customer Rating',
                    collapseButtonText: function (options, { html }) {
                        return html`<i class="bi ${options.collapsed ? 'bi-plus' : 'bi-dash'}"></i>`;
                    },
                }
            })
            // Built-in rating widget: renders real star icons + per-level counts, uses
            // "N & up" semantics, and clears the refinement when you click the active row
            // (so no separate "clear" item is needed). Star colors come from CSS (the
            // reset-min theme strips them) — see .ais-RatingMenu-starIcon in algolia-search.css.
            (instantsearch.widgets.ratingMenu)
            ({
                container: container,
                attribute: 'averageRating',
            }),
            container => instantsearch.widgets.panel({
                collapsed: () => {
                    return false;
                },
                templates: {
                    header: 'Color',
                    collapseButtonText: function (options, { html }) {
                        return html`<i class="bi ${options.collapsed ? 'bi-plus' : 'bi-dash'}"></i>`;
                    },
                }
            })(instantsearch.widgets.refinementList)
            ({
                container: container,
                attribute: 'colors',
                limit: 1000,
                sortBy: ['count:desc'],
                templates: {
                    item(item, { html }) {
                        const { url, label, count, isRefined } = item;
                        return html`
                    <input type="checkbox" id="${label.split("||")[0]}" hidden/>
                        <label
                        class="color-refinement-item"
                        for="${label.split("||")[0]}"
                        style="background:#${label.split("||")[1]};"
                        aria-label="${label.split("||")[0]}"
                        data-color-name="${label.split("||")[0]}">
                    </label>` ;
                    }
                },
                cssClasses: {
                    root: 'tag-ais-color-refinement-container',
                    list: 'tag-ais-color-refinement-list',
                }
            })
        ]
    }),
    instantsearch.widgets.breadcrumb({
        container: '#js-aisBreadCrumbs',
        attributes: [
            'hierarchicalCategories.lvl0',
            'hierarchicalCategories.lvl1'
        ],
        templates: {
            home() {
                return null; // Return empty to hide home breadcrumb
            }
        }
    }),
    instantsearch.widgets.pagination({
        container: '#js-aisPagination'
    }),

    instantsearch.widgets.stats({
        container: '#js-aisStats',
        templates: {
            text(data, { html }) {
                const paginationLimit = 1000; // Algolia's default paginationLimitedTo setting

                // Determine the effective number of accessible results
                let effectiveMaxResults;
                let isLimited = false;

                if (data.nbSortedHits !== undefined && data.nbSortedHits !== null) {
                    // When sorting, nbSortedHits tells us the actual limit
                    effectiveMaxResults = data.nbSortedHits;
                    isLimited = data.nbSortedHits < data.nbHits;
                } else {
                    // When not sorting, assume pagination limit applies if nbHits exceeds it
                    effectiveMaxResults = Math.min(data.nbHits, paginationLimit);
                    isLimited = data.nbHits > paginationLimit;
                }

                // Show warning if results are limited
                const limitWarning = isLimited
                    ? ` (showing first ${effectiveMaxResults.toLocaleString()} of ${data.nbHits.toLocaleString()})`
                    : '';

                return html`<span>${effectiveMaxResults.toLocaleString()} Items${limitWarning}</span>`;
            }
        }
    }),
    instantsearch.widgets.stats({
        container: '#js-aisPaginationStats',
        templates: {
            text(data, { html }) {
                const firstProduct = data.page * data.hitsPerPage + 1;
                const paginationLimit = 1000; // Algolia's default paginationLimitedTo setting

                // Determine the effective number of accessible results
                let effectiveMaxResults;
                let isLimited = false;

                if (data.nbSortedHits !== undefined && data.nbSortedHits !== null) {
                    // When sorting, nbSortedHits tells us the actual limit
                    effectiveMaxResults = data.nbSortedHits;
                    isLimited = data.nbSortedHits < data.nbHits;
                } else {
                    // When not sorting, assume pagination limit applies if nbHits exceeds it
                    effectiveMaxResults = Math.min(data.nbHits, paginationLimit);
                    isLimited = data.nbHits > paginationLimit;
                }

                const lastProduct = Math.min(effectiveMaxResults, (data.page + 1) * data.hitsPerPage);

                // Show warning if results are limited
                const limitWarning = isLimited
                    ? ` (showing first ${effectiveMaxResults.toLocaleString()} of ${data.nbHits.toLocaleString()})`
                    : '';

                return html`<span>Showing products ${firstProduct}-${lastProduct} of ${effectiveMaxResults.toLocaleString()}${limitWarning} Total Products</span>`;
            }
        },
        cssClasses: {
            text: ['tag-ais-bottom-stats'],
        },
    }),
    instantsearch.widgets.hitsPerPage({
        container: '#js-aisHitsPerPage',
        items: [
            { label: '60', value: 60, default: true },
            { label: '120', value: 120 },
            { label: '180', value: 180 },
        ],
        cssClasses: {
            select: [
                'form-select',
            ],
        }
    }),
    instantsearch.widgets.sortBy({
        container: '#js-aisSortBy',
        items: [
            { label: 'Featured Products', value: indexName }, //uses main index. currently sorted by price
            { label: 'Name', value: `${indexName}_name_asc` },
            { label: 'Price - Low to High', value: `${indexName}_price_asc` },
            { label: 'Price - High to Low', value: `${indexName}_price_desc` },
            { label: 'Item Number', value: `${indexName}_sku` },
            { label: 'Minimum Quantity', value: `${indexName}_minqty` },
            { label: 'Newest', value: `${indexName}_newest` },
            { label: 'Top Rated', value: `${indexName}_rating_desc` },
        ],
        cssClasses: {
            select: [
                'form-select',
            ],
        }
    }),
    //show results button mobile
    instantsearch.widgets.stats({
        container: '#js-aisShowFilterResults',
        templates: {
            text: function (data, { html }) {
                const paginationLimit = 1000; // Algolia's default paginationLimitedTo setting

                // Determine the effective number of accessible results
                let effectiveMaxResults;
                let isLimited = false;

                if (data.nbSortedHits !== undefined && data.nbSortedHits !== null) {
                    // When sorting, nbSortedHits tells us the actual limit
                    effectiveMaxResults = data.nbSortedHits;
                    isLimited = data.nbSortedHits < data.nbHits;
                } else {
                    // When not sorting, assume pagination limit applies if nbHits exceeds it
                    effectiveMaxResults = Math.min(data.nbHits, paginationLimit);
                    isLimited = data.nbHits > paginationLimit;
                }

                // Show warning if results are limited
                const limitWarning = isLimited
                    ? ` (showing first ${effectiveMaxResults.toLocaleString()} of ${data.nbHits.toLocaleString()})`
                    : '';

                return html`
                    <button class="btn tag-btn-theme-primary w-100">
                        Show ${effectiveMaxResults.toLocaleString()} Results${limitWarning}
                    </button>
                ` ;
            },
        }
    }),
    //clear results button mobile
    customResetFilterBtn({
        container: '#js-aisResetFilterResults',
    }),

]);

search.start();

// Safety net: if the Algolia request errors out, still release prerender.io
// rather than letting it wait for a render that will never carry hits.
search.on('error', () => {
    window.prerenderReady = true;
});

// Track last state we fired a view event for, so we only re-fire when results actually change
let lastViewedState = null;

// add accessibility - aria label to results per page selector
search.on('render', () => {
    const results = search.helper?.lastResults;

    // A resolved result set - even a legitimate "no results found" one -
    // means the grid has finished painting, so prerender.io can snapshot now.
    if (results && !window.prerenderReady) {
        window.prerenderReady = true;
    }

    if (results && results.hits && results.hits.length > 0) {
        // Update JSON-LD on every real results change
        updateJsonLD(
            results.hits,
            results.nbHits,
            results.page,
            results.hitsPerPage
        );

        // Build a fingerprint of the current result set: page + objectIDs + active filters
        const currentObjectIDs = results.hits.map(hit => hit.objectID).join(',');
        const currentFilters = JSON.stringify(results.facetsRefinements || {}) +
            JSON.stringify(results.disjunctiveFacetsRefinements || {}) +
            JSON.stringify(results.numericRefinements || {});
        const currentState = `${results.page}|${currentFilters}|${currentObjectIDs}`;

        // Only fire if this is a genuinely new set of results
        if (currentState !== lastViewedState && typeof window.aa === 'function') {
            const objectIDs = results.hits.slice(0, 20).map(hit => hit.objectID);
            window.aa('viewedObjectIDs', {
                index: results.index,
                eventName: 'Hits Viewed',
                objectIDs: objectIDs,
                url: cleanUrl(window.location.href)
            });
            lastViewedState = currentState;
            console.log('Sent hits viewed event for', objectIDs.length, 'products');
        }
    }

    const select = document.querySelector('#js-aisHitsPerPage select');
    if (select && !select.hasAttribute('aria-label')) {
        select.setAttribute('aria-label', 'Results per page');
    }

    // add accessibility - aria label to button collapse
    const collapseButtons = document.querySelectorAll('.ais-Panel-collapseButton');
    collapseButtons.forEach(btn => {
        if (btn.tagName.toLowerCase() === 'button' && !btn.hasAttribute('aria-label')) {
            btn.setAttribute('aria-label', 'Toggle filter group');
        }
    });

    // add rel="next" and rel="prev" to pagination links
    const prevLink = document.querySelector('.ais-Pagination-item--previousPage .ais-Pagination-link');
    if (prevLink && !prevLink.closest('.ais-Pagination-item--disabled')) {
        prevLink.setAttribute('rel', 'prev');
    }

    const nextLink = document.querySelector('.ais-Pagination-item--nextPage .ais-Pagination-link');
    if (nextLink && !nextLink.closest('.ais-Pagination-item--disabled')) {
        nextLink.setAttribute('rel', 'next');
    }

    // Remove home breadcrumb item if it exists (hides both link and separator)
    const homeBreadcrumb = document.querySelector('#js-aisBreadCrumbs .ais-Breadcrumb-item:first-child');
    if (homeBreadcrumb && homeBreadcrumb.textContent.trim() === '') {
        homeBreadcrumb.remove();
    }

    // Dynamic category content: fetch updated heading/header/footer when category changes.
    // Uses helper.state (the actual search parameters) rather than getUiState() which may
    // omit refinements it considers "default" from initialUiState.
    if (categoryName.length > 0 && search.helper) {
        const refinements = search.helper.state.hierarchicalFacetsRefinements
            && search.helper.state.hierarchicalFacetsRefinements['hierarchicalCategories.lvl0'];
        const currentRefinement = (refinements && refinements.length > 0) ? refinements[0] : null;

        if (lastCategoryRefinement === '__initial__') {
            // First render — seed the tracker with the live state so we don't
            // re-fetch content the server already rendered.
            lastCategoryRefinement = currentRefinement;
        } else if (currentRefinement !== lastCategoryRefinement) {
            lastCategoryRefinement = currentRefinement;

            if (currentRefinement) {
                const parts = currentRefinement.split(' > ');
                const parentName = parts[0] ? parts[0].trim() : null;
                const childName = parts.length > 1 ? parts[1].trim() : null;

                var params = new URLSearchParams();
                if (parentName) params.set('parent', parentName);
                if (childName) params.set('child', childName);

                fetch('/api/category-content?' + params.toString())
                    .then(function (r) { return r.json(); })
                    .then(function (data) {
                        var headingContainer = document.getElementById('js-categoryHeadingContainer');
                        var headerContent = document.getElementById('js-categoryHeaderContent');
                        var footerContent = document.getElementById('js-categoryFooterContent');

                        if (headingContainer) {
                            if (data.heading) {
                                headingContainer.innerHTML = '<h1 class="pb-2 mb-3 fs-2 border-bottom">' + data.heading + '</h1>';
                                headingContainer.style.display = '';
                            } else {
                                headingContainer.innerHTML = '';
                                headingContainer.style.display = 'none';
                            }
                        }
                        if (headerContent) {
                            headerContent.innerHTML = data.headerContent || '';
                        }
                        if (footerContent) {
                            footerContent.innerHTML = data.footerContent || '';
                        }

                        // Update the tracked pathname. The router's push()
                        // will use this on its next URL write.
                        if (data.url) {
                            categoryPathname = data.url;
                        }

                        // Update document title
                        if (data.title) {
                            document.title = data.title;
                        }
                    })
                    .catch(function (err) { console.warn('Failed to fetch category content:', err); });
            } else {
                // No category selected — clear dynamic content
                var headingContainer = document.getElementById('js-categoryHeadingContainer');
                var headerContent = document.getElementById('js-categoryHeaderContent');
                var footerContent = document.getElementById('js-categoryFooterContent');
                if (headingContainer) { headingContainer.innerHTML = ''; headingContainer.style.display = 'none'; }
                if (headerContent) { headerContent.innerHTML = ''; }
                if (footerContent) { footerContent.innerHTML = ''; }
            }
        }
    }

});
